import { render, staticRenderFns } from "./seltos-videopicstext-keji.vue?vue&type=template&id=47a3b3b0"
import script from "./seltos-videopicstext-keji.vue?vue&type=script&lang=js"
export * from "./seltos-videopicstext-keji.vue?vue&type=script&lang=js"
import style0 from "./seltos-videopicstext-keji.vue?vue&type=style&index=0&id=47a3b3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports